import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 0.75rem;
  align-items: center;

  p {
    font-size: 1.25rem;
    font-weight: ${themeGet('fontWeights.medium')};
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-bottom: 1rem;

    p {
      font-size: 1.5rem;
    }
  }
`;

export const Body = styled.div`
  border-top: 1px solid ${themeGet('colors.cta-border-grey')};
  padding-top: 0.75rem;
  p {
    color: ${themeGet('colors.grey-text')};
    font-size: 0.875rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    padding-top: 1rem;

    p {
      font-size: 1rem;
    }
  }
`;

export const Card = styled.div`
  border-radius: 0.75rem;
  padding: 1.5rem;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || themeGet('colors.white')};
  box-shadow: 0px 4px 28px 0px rgba(0, 0, 0, 0.25);

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    border-radius: 1rem;
    padding: 2.5rem;
  }
`;
